import { createClient } from '@/shared/api';
import ME_QUERY from '../queries/me';

/**
 * Loads the signed-in user's own profile. Runs ME_QUERY on a fresh Apollo client and returns the me field without inspecting errors.
 *
 * @returns The current user record, or undefined.
 */
const fetchMe = async () => {
  const client = createClient();
  const result = await client.query({
    query: ME_QUERY,
  });
  return result?.data?.me;
};

export default fetchMe;
